import { AutoComplete, Input } from "antd";
import React, { useState, useEffect } from "react";

import "./stylesCustomAutoComplete.css";
import { SearchOutlined } from "@ant-design/icons";

function CustomAutoComplete({
  allOptions = [],
  placeholder = "Search",
  handleChange,
  clearOptions,
  selector = "game_id",
  bgColor = "transparent",
  value = "",
}) {
  const [options, setOptions] = useState(allOptions);

  const onSearch = (searchText) => {
    if (!searchText) {
      setOptions(allOptions);
      clearOptions();
      return;
    }

    const filtered = allOptions.filter((option) =>
      option.value.toLowerCase().includes(searchText.toLowerCase())
    );
    setOptions(filtered);
  };

  const onSelect = (selectedValue) => {
    const selectedItem = allOptions.find(
      (option) => option.value === selectedValue
    );
    console.log("selectedItem", selectedItem);
    if (selectedItem) {
      handleChange?.(selectedItem[selector]); 
    }
  };

  useEffect(() => {
    setOptions(allOptions);
  }, [allOptions]);

  return (
    <AutoComplete
      className="custom-autocomplete"
      options={options}
      value={value}
      onSelect={onSelect}
      onSearch={onSearch}
      onChange={handleChange}
      placeholder={placeholder}
      allowClear
      style={{
        width: "100%",
        background: "transparent",
      }}
    >
      <Input
        style={{
          background: bgColor,
        }}
        prefix={<SearchOutlined style={{ fontSize: "18px", color: "#92929E" }} />}
      />
    </AutoComplete>
  );
}

export default CustomAutoComplete;
